import script from "./RemoveUploader.vue?vue&type=script&setup=true&lang=js"
export * from "./RemoveUploader.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__